//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { OpOperatorGroup } from '../../models/core'
import { Enums } from '../../models/common'
import { OpValidateInfo } from '../../models/custom'

import { CommonHelper, ToastHelper, LocalizationHelper, LogHelper, ConvertHelper } from '../../helpers'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { OpValidateInfoMessage } from '../../models/custom/op-validate-info-message'

//#region Public Types

export const OPERATOR_GROUP_SERVICE_NAME = 'OperatorGroupService'
export const OPERATOR_GROUP_SERVICE_PROVIDER_NAME = 'OperatorGroupServiceProvider'

//#endregion

export class OperatorGroupService {

    // #region Consts

    public static get FILE_NAME_PREFIX(): string { return 'operator-group' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdOperatorGroup }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Operator_Group }
    public static get LOG_PREFIX(): string { return '[SIMAX.Modules.OperatorGroup]' }

    // #endregion


    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Save

    public saveOperatorGroup(operatorGroupToSave: OpOperatorGroup, isBulkSave: boolean = false): JQueryPromise<OpOperatorGroup> {
        return this
            .validateOperatorGroup(operatorGroupToSave)
            .then(() => {
                return this.userSessionService
                    .getDataProvider().OperatorGroup
                    .saveOperatorGroup(operatorGroupToSave)
                    .then((savedObject: OpOperatorGroup) => {
                        if (!isBulkSave) {
                            ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, OperatorGroupService.SIMAX_MODULE_NAME))
                            CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.operatorGroupSaved, true, 0)
                        }

                        return savedObject
                    })
                    .fail((error: any) => {
                        ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVE_ERROR, OperatorGroupService.SIMAX_MODULE_NAME))
                        LogHelper.warn(OperatorGroupService.LOG_PREFIX, `Unable to save OperatorGroup with id ${operatorGroupToSave.idOperatorGroup}.`, error)

                        return $.Deferred().reject(error).promise()
                    })
            })
    }

    //#endregion


    //#region Validation

    private displayValidationToast(validationResult: OpValidateInfo): void {
        if (validationResult != null) {
            const validationMessage: OpValidateInfoMessage = _.first(validationResult.Result)

            if (validationMessage != null && validationMessage.Message != null) {
                ToastHelper.showError(validationMessage
                    .Message
                    .replace(/\n|  /gi, (toReplace: string): string => {
                        if (toReplace === '\n') {
                            return '<br/>'
                        } else if (toReplace === '  ') {
                            return '&nbsp;&nbsp;'
                        }
                        return toReplace
                    }))
            } else {
                ToastHelper.showError(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
            }
        }
    }

    private validateOperatorGroup(operatorGroupToSave: OpOperatorGroup): JQueryPromise<OpValidateInfo[]> {
        return this.userSessionService
            .getDataProvider().OperatorGroup
            .validateOperatorGroup([operatorGroupToSave])
            .then((validationResult: OpValidateInfo[]) => {
                const operatorGroupValidationResult: OpValidateInfo = _.first(validationResult)

                if (operatorGroupValidationResult == null || operatorGroupValidationResult.Status === Enums.ValidationStatus.Correct) {
                    return validationResult
                }

                return $.Deferred().reject(operatorGroupValidationResult).promise()
            })
            .fail((error: any) => {
                if (error instanceof OpValidateInfo) {
                    this.displayValidationToast(error)

                    LogHelper.warn(OperatorGroupService.LOG_PREFIX, `OperatorGroup with id ${operatorGroupToSave.idOperatorGroup} validation status: ${error.Status}`)

                } else {
                    ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                    LogHelper.warn(OperatorGroupService.LOG_PREFIX, `Unable to validate OperatorGroup with id ${operatorGroupToSave.idOperatorGroup}.`, error)
                }

                return $.Deferred().reject(error).promise()
            })
    }

    //#endregion
}

export class OperatorGroupServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new OperatorGroupService(userSessionService)
    }]

    //#endregion
} 